import { MutableRefObject, Ref, useCallback } from "react"

export const useMergeRefs = <T = HTMLElement>(
    ...refs: (Ref<T> | MutableRefObject<T> | undefined | null)[]
) => {
    return useCallback(
        (node: T | null) => {
            refs.forEach((ref) => {
                if (!ref) return

                if (typeof ref === "function") {
                    ref(node)
                } else {
                    ;(ref as MutableRefObject<T | null>).current = node
                }
            })
        },
        [refs]
    )
}
